import { useState } from "react";
import "../../styling/Dashboard.css";
import { Link as LinkIcon } from "lucide-react";
import { useSelector } from "react-redux";

const BookABoothRightPanel = () => {
  const [copiedUrl, setCopiedUrl] = useState(null);
  const user = useSelector((state) => state.auth.user);
  const businessId=user?.businessId

  const bookABoothLink= "https://beta.boothbloom.com/book-a-booth?businessId="+ businessId;
  const clientUrl="https://beta.boothbloom.com/client-login?businessId="+ businessId;

  const handleCopy = (copyUrl) => {
    navigator.clipboard.writeText(copyUrl).then(() => {
      setCopiedUrl(copyUrl);
      setTimeout(() => setCopiedUrl(null), 2000);
    });
  }; 

  return (
    <div className="right-panel" style={{ marginTop: "0px",height: "auto"}}>
      <div className="right-panel-content" style={{ marginTop:"-10px", border: 'none', borderBottom:"solid 0.5px #625C73", borderRadius:"0px", paddingBottom:"10px", paddingx: '20px'}}>

        <h4 style={{ color: "#1C1154", marginBottom: "5px", fontWeight: 600 }}>Book-A-Booth Link</h4>
        <div style={{ paddingBottom: "15px" }}>
          Share links or paste on your website or directly to your contacts.
        </div>

        <div
          style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", paddingBottom: "15px" }}
          onClick={() => handleCopy(bookABoothLink)}
        >
          <LinkIcon size={20} color="#1C1154" />
          <span style={{ color: "#1C1154", fontSize: "14px", fontWeight: 600 }}>
            {copiedUrl === bookABoothLink ? "Copied!" : "Copy Link"}
          </span>
        </div>
      </div>

   
      <div className="right-panel-content" style={{ border: "none", padding: "0 20px" }}>
        <h4 style={{ color: "#1C1154", marginBottom: "5px", fontWeight: 600 }}>Client Portal</h4>
        <div style={{ paddingBottom: "15px" }}>
          Share links or paste on your website or directly to your contacts.
        </div>

        <div
          style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", paddingBottom: "15px" }}
          onClick={() => handleCopy(clientUrl)}
        >
          <LinkIcon size={20} color="#1C1154" />
          <span style={{ color: "#1C1154", fontSize: "14px", fontWeight: 600 }}>
            {copiedUrl === clientUrl ? "Copied!" : "Copy Link"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookABoothRightPanel;
